import type Luminary from '@lumen5/luminary';

import type { Tool } from '../tools/Tool';
import type { ConversationMessage } from '../types';

import { AddFontsTool } from './AddFontsTool';
import { EditHtmlAssetTool } from './EditHtmlAssetTool';
import { ReadHtmlAssetTool } from './ReadHtmlAssetTool';
import { WriteDesignSystemTool } from './WriteDesignSystemTool';
import { WriteHtmlAssetTool } from './WriteHtmlAssetTool';
import { WritePlanTool } from './WritePlanTool';

import type { AppDispatch, GetRootState } from 'js/src/libs/RootState';

export function buildDesignAuthoringTools(
    luminary: Luminary,
    dispatch: AppDispatch,
    getState: GetRootState,
    getConversationMessages?: () => ConversationMessage[],
): Tool[] {
    const args = { luminary, dispatch, getState };
    return [
        new AddFontsTool(args),
        new WriteDesignSystemTool(args),
        new WritePlanTool({ ...args, getConversationMessages }),
        new WriteHtmlAssetTool({ ...args, getConversationMessages }),
        new EditHtmlAssetTool({ ...args, getConversationMessages }),
        new ReadHtmlAssetTool(args),
    ];
}
